/* ============================================================
   DDSE — Gallery Filtering + Lightbox
   ============================================================ */ (function() {
    // ─── Filter Tabs ───
    const tabs = document.querySelectorAll('.filter-tab');
    const items = document.querySelectorAll('.gallery-item');
    if (tabs.length === 0 || items.length === 0) return;
    tabs.forEach((tab)=>{
        tab.addEventListener('click', ()=>{
            tabs.forEach((t)=>t.classList.remove('active'));
            tab.classList.add('active');
            const category = tab.dataset.filter;
            items.forEach((item)=>{
                if (category === 'all' || item.dataset.category === category) {
                    item.style.display = '';
                    item.style.opacity = '0';
                    requestAnimationFrame(()=>{
                        item.style.transition = 'opacity 0.4s ease';
                        item.style.opacity = '1';
                    });
                } else {
                    item.style.opacity = '0';
                    setTimeout(()=>{
                        item.style.display = 'none';
                    }, 400);
                }
            });
        });
    });
    // ─── Lightbox ───
    const lightbox = document.getElementById('lightbox');
    const lightboxImg = document.getElementById('lightbox-img');
    const lightboxClose = document.getElementById('lightbox-close');
    if (!lightbox || !lightboxImg) return;
    items.forEach((item)=>{
        item.addEventListener('click', ()=>{
            const img = item.querySelector('img');
            if (img) {
                lightboxImg.src = img.src;
                lightboxImg.alt = img.alt;
            }
            lightbox.classList.add('active');
            document.body.style.overflow = 'hidden';
        });
    });
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (e)=>{
        if (e.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && lightbox.classList.contains('active')) closeLightbox();
    });
    function closeLightbox() {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
    }
})();

//# sourceMappingURL=gallery.adaa8874.js.map
